import React, { useState } from 'react';
import { FileAudio } from '@phosphor-icons/react';
import type { GeneratedAudio } from '../../../../types/generatedAudio';
import { Item } from './Item';
import { ActionMenu } from './ActionMenu';

interface GeneratedAudioItemProps {
  audio: GeneratedAudio;
  onPreview: (audio: GeneratedAudio) => void;
  onRename: (audio: GeneratedAudio) => void;
  onDelete: (audio: GeneratedAudio) => void;
  isNested?: boolean;
}

export const GeneratedAudioItem: React.FC<GeneratedAudioItemProps> = ({
  audio,
  onPreview,
  onRename,
  onDelete,
  isNested = true,
}) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  const label = audio.name || audio.provider;

  return (
    <>
      <Item
        icon={<FileAudio size={16} />}
        label={label}
        isNested={isNested}
        onClick={() => onPreview(audio)}
        onMenuClick={anchor => setAnchorEl(anchor)}
      />
      <ActionMenu
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        onRename={() => {
          setAnchorEl(null);
          onRename(audio);
        }}
        onDelete={() => {
          setAnchorEl(null);
          onDelete(audio);
        }}
      />
    </>
  );
};
